var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeadingButtons',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('h2',[_vm._v("Storage")])]},proxy:true},{key:"buttons",fn:function(){return [_c('OverviewFlushCache',{staticClass:"button-round"})]},proxy:true}])}),_c('BaseCard',{attrs:{"grow":true}},[_c('DonutChart',{attrs:{"values":_vm.donutChartValues}}),_c('BaseStats',{attrs:{"stats":[
        {
          value: (_vm.memoryUsed + "/" + _vm.totalMemory),
          label: 'memory used / total memory',
          small: true,
        },
        {
          value: _vm.stats.curr_items,
          label: 'items',
          small: true,
        } ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }